import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AuthenticationObserver {
  // Observable flag source
  private authenticationNotifier = new BehaviorSubject<boolean>(false);

  // Observable flag stream
  // eslint-disable-next-line @typescript-eslint/member-ordering
  authenticationUpdatesEmitter$ = this.authenticationNotifier.asObservable();

  // service command
  sendAuthenticationUpdates(value) {
    this.authenticationNotifier.next(value);
  }
}
